<template>
    <component
        :is="as"
        @click="fireEvent()"
        class="cursor-pointer"
    >
        <slot
            :active="modelValue === value && !disabled"
            :value="value"
            :disabled="disabled"
        />
    </component>
</template>

<script lang="ts" setup>
    import type { PropType } from 'vue'

    const emits = defineEmits(['update:modelValue'])

    const props = defineProps({
        value: {
            type: [String, Number, Boolean, Object],
            required: true,
        },
        modelValue: {
            type: [String, Number, Boolean, Object],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        as: {
            type: String as PropType<'div' | 'button'>,
            default: 'div',
        },
    })

    const fireEvent = () => {
        if (props.disabled) {
            return
        }

        emits('update:modelValue', props.value)
    }
</script>
